<ion-button expand="full" [type]="buttonSubmitType" [ngClass]="buttonType" 
[disabled]="buttonDisabled">
{{buttonText}}
</ion-button>
